import { motion } from 'framer-motion'

import { products, keyProperties } from '../data/mockData'
import { ArrowRight, Leaf, Shield, Droplets } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import Hero from '../compenents/Hero'
import ProductCard, { EcothermHero } from '../compenents/ProductCard'
import PropertyCard from '../compenents/PropertyCard'
import ApplicationGuide from '../compenents/ApplicationGuide'

const Home = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen">
      <Hero />
      <EcothermHero/>
      <ApplicationGuide/>
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gradient mb-4">Nos Produits Naturels</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">100% naturels, sans eau, sans réactions allergiques</p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {products.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <ProductCard product={product} />
              </motion.div>
            ))}
          </div>
          
          <div className="text-center">
            <button onClick={() => navigate('/products')} className="btn-primary inline-flex items-center gap-2">
              Découvrir Tous Les Produits
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-b from-white to-green-50 moroccan-pattern">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-gradient mb-4">Propriétés Écologiques</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Des matériaux révolutionnaires pour un avenir durable</p>
          </motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {keyProperties.slice(0, 6).map((property, index) => (
              <motion.div
                key={property.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <PropertyCard property={property} />
              </motion.div>
            ))}
          </div>
          
          <div className="text-center">
            <button onClick={() => navigate('/properties')} className="btn-primary inline-flex items-center gap-2">
              Voir Toutes Les Propriétés
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="bg-white rounded-2xl p-8 shadow-lg card-hover"
            >
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <Leaf className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">100% Naturel</h3>
              <p className="text-gray-600 leading-relaxed">Nos produits sont composés uniquement de matériaux naturels et organiques, sans substances chimiques nocives.</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-2xl p-8 shadow-lg card-hover"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <Droplets className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">Sans Eau</h3>
              <p className="text-gray-600 leading-relaxed">Application innovante sans besoin d'eau pour le mélange, économisant cette ressource précieuse.</p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="bg-white rounded-2xl p-8 shadow-lg card-hover"
            >
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                <Shield className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">Sécurité Maximale</h3>
              <p className="text-gray-600 leading-relaxed">Aucune réaction allergique, pas de substances cancérigènes, protection contre le radon et les polluants.</p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-r from-green-600 to-green-700 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Prêt à Révolutionner Votre Isolation ?</h2>
            <p className="text-xl mb-8 opacity-90">Découvrez comment ECOTHERM peut transformer votre projet avec des solutions écologiques et performantes</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => navigate('/contact')} className="bg-white text-green-700 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-50 transition-all duration-300 hover:scale-105 shadow-lg">
                Contactez-Nous
              </button>
              <button onClick={() => navigate('/technical')} className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-green-700 transition-all duration-300">
                Spécifications Techniques
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default Home